import React, { useMemo } from 'react';
import SearchableCombobox from './SearchableCombobox';
import COUNTRIES from '../../data/countries';

const CountrySelect = ({
  value,
  onChange,
  name,
  placeholder = 'Select country',
  isDisabled = false,
  isInvalid = false,
}) => {
  const options = useMemo(
    () => COUNTRIES.map((country) => ({ label: country, value: country })),
    []
  );

  return (
    <SearchableCombobox
      options={options}
      value={value}
      onChange={onChange}
      name={name}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      emptyStateText="No countries available"
      noResultsText="No matching countries"
    />
  );
};

export default CountrySelect;
